<template>
	<div class="h-panel-body padding font-bold">
		<div class="h-panel-bar">
			<span class="h-panel-title">销售订单</span>
			<div class="hbtnbox">
				<button class="h-btn h-btn-blue" @click="exportExcel()">导出</button>
				<!-- <button class="h-btn">打印</button> -->
			</div>
		</div>

		<div class="filterbox">
			<div class="filtertimebox">
				<a-radio-group :value="size" @change="changeday" style="font-weight:normal">
					<a-radio-button value="today" >
						今天
					</a-radio-button>
					<a-radio-button value="yesterday">
						昨天
					</a-radio-button>
					<a-radio-button value="7days">
						7天
					</a-radio-button>
					<a-radio-button value="30days">
						30天
					</a-radio-button>
					<a-radio-button value="thismonth">
						本月
					</a-radio-button>
					<a-radio-button value="lastmonth">
						上月
					</a-radio-button>
					<a-radio-button value="whole">
						全部
					</a-radio-button>
				</a-radio-group>
			</div>
			<div class="filterdatebox">
				<a-range-picker :locale="locale"  @change="onChange" />
			</div>

			<div>
				<span style="padding-left:20px;font-weight:normal;padding-right:15px;">搜索</span>
				<a-input placeholder="输入搜索内容" style="width:150px;" v-model="seltitleTally.orderSn"  />
				<a-select default-value="订单号" style="width: 80px;font-weight:normal">
					<a-select-option value="订单号">
						订单号
					</a-select-option>
				</a-select>
				<a-button type="primary" style="margin-left:20px;" @click="gosearch">
					查询
				</a-button>
			</div>
		</div>


		<div class="databox">
			<dl>
				<dt>
					销售额
				</dt>
				<dd>{{titletally.orderAmount}}</dd>
			</dl>
			<dl>
				<dt>
					退款额
				</dt>
				<dd>{{titletally.refundAmount}}</dd>
			</dl> 
			<dl>
				<dt>
					订单量
				</dt>
				<dd>{{titletally.cnt}}</dd>
			</dl>
			<dl>
				<dt>
					佣金金额
				</dt>
				<dd>{{titletally.rebateAmount}}</dd>
			</dl>
			<dl>
				<dt>
					现金支付
				</dt>
				<dd>{{titletally.cashAmount}}</dd>
			</dl>
			<dl>
				<dt>
					余额支付
				</dt>
				<dd>{{titletally.balanceAmount}}</dd>
			</dl>
			<dl>
				<dt>
					消费金支付
				</dt>
				<dd>{{titletally.consumeAmount}}</dd>
			</dl>
			<dl>
				<dt>
					商家支付
				</dt>
				<dd>{{titletally.storeBalanceAmount}}</dd>
			</dl>
		</div>


		<div class="tablessbox">

			<!-- <a-table :columns="columns" :data-source="data" bordered :scroll="{ x: 2000 }">
				<a slot="action" slot-scope="text" href="javascript:;">action</a>
			</a-table> -->

			<table class="tableorderlist">
				<tr class="headtr">					
					<td>订单号</td>
					<td style="text-align:center;width:110px;">订单分类</td>
					<td style="text-align:center;width:110px;">订单金额</td>
					<td>用户信息</td>
					<td style="text-align:center;width:110px;">添加时间</td>
					<td style="text-align:center;width:110px;">订单状态</td>
					<!-- <td style="text-align:center;width:110px;">配送状态</td> -->
					<td style="text-align:center;width:110px;">支付时间</td>
					<td style="text-align:center;width:110px;">实付金额</td>
					<td style="text-align:center;width:110px;">退款金额</td>
					<td style="text-align:center;width:110px;">完成时间</td>
					<td style="text-align:center;width:110px;">佣金</td>
					<td style="text-align:center;width:110px;">在线支付</td>
					<td style="text-align:center;width:110px;">余额支付</td>
					<td style="text-align:center;width:110px;">消费金支付</td>
					<td style="text-align:center;width:110px;">商家支付</td>
					<!-- <td>社区</td>
					<td>销售人员</td> -->
				</tr>
				<tbody v-if="orderrecord.length>0">
				<tr v-for="(item,index) in orderrecord" :key="index">
					<td style="width:100px"><span>{{item.orderSn}}</span></td>
					<td style="text-align:center;">{{item.orderType==1 ? '商城': item.orderType==2 ? '外卖' : item.orderType==3 ? '团购' : item.orderType==4 ? '生鲜' :
						 item.orderType==5 ? '品牌' : item.orderType==6 ? '医药' : item.orderType==7 ? '食疗' : item.orderType==8 ? '生活服务' :
						  item.orderType==9 ? '优惠买单' : item.orderType==10 ? '房产' : item.orderType==11 ? '汽车' : item.orderType==12 ? '成家立业' :  item.orderType==13 ? '店内收银' : ''}}</td>
					<td style="text-align:center;">{{item.orderAmount}}</td>
					<td style="width:170px">
						客户姓名：{{item.buyerName}}<br/>
						客户手机：{{item.buyerPhone}}<br/>
						收货地址：{{item.address}}·
					</td>
					<td style="text-align:center;">
						{{item.orderTime}}
					</td>
					<td style="text-align:center;">{{item.state==1 ? '已支付' : item.state==2 ? '已完成' : '交易关闭'  }}</td>
					<!-- <td style="text-align:center;">{{item.freightState==0 ? '订单生产' : item.freightState==1 ? '配送员接单' : item.freightState==2 ? '配送员取货' : item.freightState==3 ? '配送员配送' : item.freightState==4 ? '配送员送达' : '配送失败' }}</td> -->
					<td style="text-align:center;">{{item.payTime}}</td>
					<td style="text-align:center;">{{item.payAmount}}</td>
					<td style="text-align:center;">{{item.refundAmount}}</td>
					<td style="text-align:center;">{{item.completeTime}}</td>
					<td style="text-align:center;width:90px">{{item.rebateAmount}}</td>
					<td style="text-align:center;">{{item.payCash}}</td>
					<td style="text-align:center;">{{item.payBalance}}</td>
					<td style="text-align:center;">{{item.payConsume}}</td>
					<td style="text-align:center;">{{item.payStoreBalance}}</td>
					
					<!-- <td>
						<dl class="rmdl" v-for="(itemss,indexss) in item.rebateList" :key="indexss">
							<dt>{{itemss.roleName}}</dt>
							<dd>昵称:{{itemss.nickName}}</dd>
							<dd>姓名:{{itemss.userName}}</dd>
							<dd>佣金:{{itemss.rebateAmount}}</dd>
						</dl>	
					</td>
					<td>
						<dl class="rmdl" v-for="(itemss,indexss) in item.rebateList" :key="indexss" v-show="itemss.rebateType==2">
							<dt>{{itemss.roleName}}</dt>
							<dd>昵称:{{itemss.nickName}}</dd>
							<dd>姓名:{{itemss.userName}}</dd>
							<dd>佣金:{{itemss.rebateAmount}}</dd>
						</dl>	

					</td> -->
				</tr>
			</tbody>	
				<tr v-else>
					<td colSpan="14" style="text-align:center;padding-top:80px;padding-bottom:100px;border:none;">没有数据！</td>
				</tr>	
			</table>
			<div class="yema" v-show="orderrecord.length>0">
				<Pagination v-model="pagination" @change="currentChange"  align="center" :small="true" layout="total,sizes,pager"></Pagination>
			</div>
			<!-- <div class="yema" v-show="orderrecord.length>0">
				<a-pagination
					v-model="current"
					:total="total"
					:page-size="pageSize">
					<template slot="buildOptionText" slot-scope="props">
					<span v-if="props.value !== '50'">{{ props.value }}条/页</span>
					<span v-if="props.value === '50'">全部</span>
					</template>
				</a-pagination>
			</div> -->
		</div>
	</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

const renderContent = (value, row, index) => {
	const obj = {
		children: value,
		attrs: {},
	};
	if (index === 4) {
		obj.attrs.colSpan = 0;
	}
	return obj;
};


const columns = [
	{ title: '系统单ID', width: 100, dataIndex: 'name', key: 'name' },
	{ title: '订单ID', width: 100, dataIndex: 'age', key: 'age' },
	{ title: '订单分类', dataIndex: 'address', key: '1' },
	{ title: '总金额', dataIndex: 'address', key: '2' },
	{ title: '用户信息', dataIndex: 'address', key: '3' },
	{ title: '添加时间', dataIndex: 'address', key: '4' },
	{ title: '订单状态', dataIndex: 'address', key: '5' },
	{ title: '配送状态', dataIndex: 'address', key: '6' },
	{ title: '支付时间', dataIndex: 'address', key: '7' },
	{ title: '实付金额', dataIndex: 'address', key: '8' },
	{ title: '退款金额', dataIndex: 'address', key: '9' },
	{ title: '完成时间', dataIndex: 'address', key: '10' },
	{ title: '佣金', dataIndex: 'address', key: '11' },
	{
		title: '社区',
		colSpan: 2,
		dataIndex: 'tel',
		customRender: (value, row, index) => {
			const obj = {
				children: value,
				attrs: {},
			};
			if (index === 2) {
				obj.attrs.rowSpan = 2;
			}
			// These two are merged into above cell
			if (index === 3) {
				obj.attrs.rowSpan = 0;
			}
			if (index === 4) {
				obj.attrs.colSpan = 0;
			}
			return obj;
		},
	},
	{
		title: 'Phone',
		colSpan: 0,
		dataIndex: 'phone',
		customRender: renderContent,
	},
	{
		title: 'Address',
		dataIndex: 'address',
		customRender: renderContent,
	},

	{
		title: '销售人员',
		key: 'operation',
		fixed: 'right',
		width: 100,
		scopedSlots: { customRender: 'action' },
	},
];

const data = [
	{
		key: '1',
		name: 'John Brown',
		age: 32,
		address: 'New York Park',
		companyAddress: 'Lake Street 42',
		companyName: 'SoftLake Co',
		tel: '0571-22098333',
		phone: 18889898888
	},
	{
		
		orderSn:'',	//订单编号
		orderType:'',//订单类型
		orderAmount:'',//订单金额
		orderTime:'',//下单时间
		state:'',//订单状态
		freightState:'',//配送状态
		payTime:'',//支付时间
		payAmount:'',//实付金额
		refundAmount:'',//退款金额
		completeTime:'',//订单完成时间
		rebateAmount:'',//佣金

	}
	
];

import { mapState } from 'vuex';
import Qs from "qs";
import axios from 'axios';
export default {
	name: "Salarymanage",
	data() {
		return {
			dataList: {},
			size: 'whole',
			locale,
			data,  //表格数据
			columns,
			titletally:{},
			moment,
			depparam:[],
			selparams:{
				departId:'',
				size:50,
				accountSetsId:'',
				state:1,
			},
			datas:[],
			dqdepss:'',
			seltitleTally:{
				accountSetsId:'',
				startTime:'',
				endTime:'',
				personId:'',
				departId:'',
				orderSn:''
			},
			departmentlist:[], //部门
			orderrecord:[],
			pagination:{
				page:1,
				size:20,
				total:0
			},
			current: 1, //页码
			pageSize: 10,
			total: 50

		}
	},
	computed: {
		...mapState(['User', 'currentAccountSets']),
		date() {
			return moment(this.accountDate);
		}
	},
	methods: {
		//销售订单列表
		getmallOrderlist(){
			var that = this;
			var seltitleTally = this.seltitleTally;
			var accountSetsId = this.User.accountSetsId;
			if(seltitleTally.startTime=='' || seltitleTally.endTime==''){ 
				var parmas = {
					accountSetsId,
					current:this.pagination.page,
					size:this.pagination.size,
					personId:seltitleTally.personId,
					departId:seltitleTally.departId,
					orderSn:seltitleTally.orderSn
				}

			}else{

				var parmas = {
					accountSetsId,
					current:this.pagination.page,
					size:this.pagination.size,
					startTime:seltitleTally.startTime,
					endTime:seltitleTally.endTime,
					personId:seltitleTally.personId,
					departId:seltitleTally.departId,
					orderSn:seltitleTally.orderSn
				}

			}
			

			this.$api.salesdata.mallOrderlist(parmas).then(res=>{				
				if(res.code==200){
					that.orderrecord = res.data.records;
					that.pagination.page= res.data.current; 
					that.pagination.total= res.data.total; 
				}
				//console.log('9999',res);
			})

		},
		currentChange(value){
			this.pagination.page= value.cur; 
			this.pagination.size=value.size;
			this.getmallOrderlist();

		},
		//部门列表
		getdepartment() {
			var accountSetsId = this.User.accountSetsId;
			var that = this;
			this.$api.wages.department(accountSetsId).then(departdata => {
				//console.log('departdata', departdata);
				if (departdata.code == 200) {
					that.departmentlist = departdata.data;
					//param = [{ title: '全部', key: 0 }, { title: '选择1', key: 1 }, { title: '选择2', key: 2 }];
					var newarr = [{ title: '全部', key: 0 }];
					departdata.data.forEach(e => {
						var arrlist = {};
						arrlist.title = e.name;
						arrlist.key = e.code;
						arrlist.accountSetsId = e.accountSetsId;
						arrlist.departId = e.id;
						newarr.push(arrlist);
					});

					that.depparam = newarr;
					that.dqdepss = that.depparam[0].title;

				}
			})

		},	
		//时间选择	
		onChange(date, dateString) {
			this.seltitleTally.startTime = dateString[0];
			this.seltitleTally.endTime = dateString[1];
			this.size = '';
			this.gettopdata();

		},
		//头部统计
		gettopdata(){

			var that = this;
			var seltitleTally = this.seltitleTally;
			var accountSetsId = this.User.accountSetsId;

			if(seltitleTally.startTime=='' || seltitleTally.endTime==''){
				var parmas = {
					accountSetsId,
					personId:seltitleTally.personId,
					departId:seltitleTally.departId,
					orderSn:seltitleTally.orderSn
				}
			}else{
				var parmas = {
					accountSetsId,
					startTime:seltitleTally.startTime,
					endTime:seltitleTally.endTime,
					personId:seltitleTally.personId,
					departId:seltitleTally.departId,
					orderSn:seltitleTally.orderSn
				}
			}
			

			this.$api.salesdata.mallOrdertop(parmas).then(res=>{
				
				if(res.code==200){
					that.titletally = res.data;
				}
				//console.log('9999',res);

			});

			//订单列表
			this.getmallOrderlist();

		},
		//查询
		gosearch(){
			this.pagination.page=1;
			this.pagination.size=20;
			this.gettopdata();

		},
		//部门筛选
		selectdep(e, key) {

			var index = key.data.key;
			if (index > 0) {
				this.dqdepss = e;
				var departId = this.departmentlist[index - 1].id;
				this.selparams.departId = departId;
				this.seltitleTally.departId = departId;
			} else {
				this.selparams.departId = '';
				this.seltitleTally.departId = '';
				this.dqdepss = '全部';
			}

		},
		//员工信息
		getstafflist() {

			var selparams = this.selparams;
		
			var accountSetsId = this.User.accountSetsId;
			var size = 50;
			var parmas = {
				accountSetsId,
				size,
				state:1,
				departId: selparams.departId
			}
			this.$api.wages.stafflist(parmas).then(data => {
				//this.datas = data.records;
				console.log('data1111', data);

				if (data.code == 200) {

					var staffarr = [];

					//console.log('data.code', data.code);

					data.data.records.forEach(e => {
						var record = {}
						record.id = e.id;
						record.name = e.name;
						record.number = e.code;
						record.department = e.departName;
						record.position = e.title;
						record.phone = e.phone;
						record.idnum = e.cardNo;
						record.state = e.state == 1 ? '在职' : '离职';
						record.datass = e;
						staffarr.push(record);
					});

					this.datas = staffarr;

					console.log('this.datas',this.datas);

				}
			})

		},
		//销售人员选择
		selygChange(e){
			//console.log('e',e);
			this.seltitleTally.personId = e;
		},
		exportExcel(){ 
			var seltitleTally = this.seltitleTally;
			var accountSetsId = this.User.accountSetsId;

			if(seltitleTally.startTime=='' || seltitleTally.endTime==''){
				var parmas = {
					accountSetsId,
					personId:seltitleTally.personId,
					departId:seltitleTally.departId,
					orderSn:seltitleTally.orderSn
				}
			}else{
				var parmas = {
					accountSetsId,
					startTime:seltitleTally.startTime,
					endTime:seltitleTally.endTime,
					personId:seltitleTally.personId,
					departId:seltitleTally.departId,
					orderSn:seltitleTally.orderSn
				}
			}
			
			
			this.$api.exportExcel.mallOrder(parmas) 
				.then(data => {
					let objectUrl = window.URL.createObjectURL(new Blob([data]))
					console.log(objectUrl);
					const link = document.createElement('a')
					link.download = '销售订单.xls'
					link.href = objectUrl
					link.click()
			})
			
			
		},
		//快捷时间点
		changeday(e){
			//console.log('e',e.target.value);
			this.size = e.target.value;
			var value = e.target.value;
			//获取完整的日期
			var date = new Date(); 
			//获取当前年份：
			var year = date.getFullYear(); 
			//获取当前月份：
			var month = date.getMonth() + 1;
			//获取当前日：
			var day = date.getDate();

			if(value=='today'){

				var time = this.getDay(0);
				console.log('time',time);

				this.seltitleTally.startTime = time;
				this.seltitleTally.endTime = time;


			}else if(value=='yesterday'){

				var time = this.getDay(-1);
				console.log('time',time);

				this.seltitleTally.startTime = time;
				this.seltitleTally.endTime = time;


			}else if(value=='7days'){

				var days7 = this.getDay(-7);
				var time = this.getDay(0);
				this.seltitleTally.startTime = days7;
				this.seltitleTally.endTime = time;


			}else if(value=='30days'){

				var days30 = this.getDay(-30);
				var time = this.getDay(0);
				this.seltitleTally.startTime = days30;
				this.seltitleTally.endTime = time;


			}else if(value=='thismonth'){

				month = (month > 9) ? month : ("0" + month);
				var time = this.getDay(0);
				var theday = year + "-" + month + "-" + '01';
				this.seltitleTally.startTime = theday;
				this.seltitleTally.endTime = time;


			}else if(value=='lastmonth'){
				
				this.seltitleTally.startTime = this.getLastMonthFirstDay();
				this.seltitleTally.endTime = this.getLastMonthAndDay();

			}else if(value=='whole'){

				this.seltitleTally.startTime = '';
				this.seltitleTally.endTime = '';

			}

			this.gettopdata();

		},
		//获取某一天
		 getDay(day) {
                var today = new Date();
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
                today.setTime(targetday_milliseconds); //注意，这行是关键代码                
                var tYear = today.getFullYear();
                var tMonth = today.getMonth();
                var tDate = today.getDate();
                tMonth = this.doHandleMonth(tMonth + 1);
                tDate = this.doHandleMonth(tDate);
                return tYear + "-" + tMonth + "-" + tDate;
            },
            doHandleMonth(month) {
                var m = month;
                if (month.toString().length == 1) {
                    m = "0" + month;
                };
                return m;
            },
			//获取上个月第一天
			getLastMonthFirstDay() {
				var date = new Date();
				date.setDate(0);
				var y = date.getFullYear(); //获取年份
				var m = date.getMonth() + 1; //获取月份
				m = m < 10 ? "0" + m : m; //月份补 0
				return [y, m, '01'].join("-");
			},
			//获取上个月最后一天
			getLastMonthAndDay(){
				var nowDate = new Date();
				var year = nowDate.getFullYear();
				var month = nowDate.getMonth();
				if(month == 0){
					month = 12;
					year = year - 1;
				}
				var lastDay = new Date(year,month,0);
				month = (month > 9) ? month : ("0" + month);
				var yyyyMMdd = year+"-"+month+"-"+lastDay.getDate();
				return yyyyMMdd;
			},
			

	},

	mounted() {
		// //获取今天的时间
		// var time = this.getDay(0);
		// this.seltitleTally.startTime = time;
		// this.seltitleTally.endTime = time;
		//获取顶部数据
		this.gettopdata();
		//获取
		this.getdepartment();
		this.getstafflist();
	}
}
</script>


<style lang="less" scoped>
.h-row>div>div {
	padding: 8px;
	border-radius: 5px;
	text-align: center;
	font-size: 20px;
	color: #000;
}

.period {
	border-radius: 3px;
	text-align: center;
	line-height: 54px;
	border: 1px solid @primary-color;
	white-space: nowrap;
	overflow: hidden;
	box-sizing: border-box;
	height: 80px;

	&:hover {
		cursor: pointer;
		box-shadow: 0 0 20px 2px rgba(102, 100, 100, 0.24), 0px 2px 4px 0px rgba(199, 198, 198, 0.5);
	}

	.month-header {
		height: 25px;
		margin: -8px -8px 0 -8px;
	}

	&.completed {
		.month-header {
			background-color: @gray1-color !important;
			line-height: 20px;
		}

		border-color: @gray1-color;

		color: #a2a2a2;

		&:hover {
			cursor: default;
			box-shadow: none;
		}
	}

	&.disable {
		opacity: 0.4;

		&:hover {
			cursor: default;
			box-shadow: none;
		}
	}
}

.h-panel-body {
	min-width: 1600px;
	background: #fff;
}

.h-panel-bar {
	display: flex;
	justify-content: space-between;
}

.filterbox {
	padding-top: 20px;
	display: flex;
	justify-content: left;
	align-items: center;
	min-width: 1600px;
}

.filterbox .filtertimebox {
	padding-right: 20px;
}

.databox {
	overflow: hidden;
	padding-top: 30px;
	padding-bottom: 20px;
	padding-left: 20px;
}

.databox dl {
	float: left;
	padding-right: 70px;
}

.databox dl dt {
	font-size: 18px;
	color: #2D2D2D
}

.databox dl dd {
	font-size: 34px;
	color: #3667EF;
}


.tableorderlist{ width:2000px;font-weight:none!important;}
.tableorderlist tr {font-weight:none!important;}
.tableorderlist tr td{  font-weight:normal; padding:10px 5px; border-bottom:1px solid #eee;}

.tableorderlist .headtr td{  font-weight:bold;}

 

.tablessbox{ min-height:600px;overflow:hidden; overflow-x:scroll;}


.tableorderlist tr td dl.rmdl{ float:left; padding-right:20px;}
.tableorderlist tr td dl.rmdl dt{ color:#1E5AEE; font-weight:bold;}

.yema{ text-align:center; padding-top:30px;}
.yema div{
	text-align:center; 
	margin: auto;
}
</style>
